export default (initialTags: string[] = [], weekTagLabel: string | null = null, initialSlug = '') => ({
  week_post: false,
  syndicationModalOpen: false,
  mobileSettingsOpen: false,
  tagInput: '',
  tags: initialTags,
  postSlug: initialSlug,

  init() {
    if (weekTagLabel) {
      this.$watch('tags', (v: string[]) => {
        this.week_post = v.some((t: string) => t.trim() === weekTagLabel);
      });
      this.week_post = initialTags.some((t: string) => t.trim() === weekTagLabel);
    }
  },

  addTag() {
    const t = (this.tagInput as string).trim().replace(/,$/, '');
    if (t && !(this.tags as string[]).includes(t)) (this.tags as string[]).push(t);
    this.tagInput = '';
  },

  removeTag(t: string) {
    this.tags = (this.tags as string[]).filter((x: string) => x !== t);
  },

  handleTagKey(e: KeyboardEvent) {
    if ((e.key === 'Enter' || e.key === ',') && (this.tagInput as string).trim()) {
      e.preventDefault();
      this.addTag();
    }
    if (e.key === 'Backspace' && !(this.tagInput as string) && (this.tags as string[]).length) {
      (this.tags as string[]).pop();
    }
  },
});
